export default {
  getProductPFMStat: {
    url: '/product/getProductPerformanceList',
    method: 'post',
    desc: '获取商品表现数据'
  },
  getProductPerformanceList: {
    url: '/performance/getProductPerformanceList',
    method: 'post',
    desc: '获取商品表现数据'
  },
  getAsinPerformanceExpandList: {
    url: '/performance/getAsinPerformanceExpandList',
    method: 'post',
    desc: '获取商品表现数据'
  },
  getProductPerformanceTotal: {
    url: '/performance/getProductPerformanceTotal',
    method: 'post',
    desc: '获取商品表现ASIN维度总计接口'
  },
  getParentAsinPerformanceExpandList: {
    url: '/performance/getParentAsinPerformanceExpandList',
    method: 'post',
    desc: '获取商品表现父ASIN维度展开列表接口'
  },
}
